module.exports = __webpack_public_path__ + "914357fd78cc3d2fcc8594909183bdb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/verrat.svg
// module id = 6
// module chunks = 0